import { createSelector } from "reselect";
import { Map } from "immutable";
import _ from "lodash";

import { FilesState as State, Image, IImage, File, FilesNormalisedEntities } from "../models";

export const getEntities = (state: State) =>
    state.files.entities ? state.files.entities : {
        images:  Map<number, Image>(),
        files:  Map<number, File>(),
    } as FilesNormalisedEntities;

export const getImages = createSelector(
    getEntities,
    (entities: FilesNormalisedEntities) => entities.images,
);

export const getFiles = createSelector(
    getEntities,
    (entities: FilesNormalisedEntities) => entities.files,
);

// Functions to hydrate the models.
export const makeHydrateImage = (entities: FilesNormalisedEntities) => (e: Image) => {
    if (e == null) {
        return e;
    }

    // Hydrate the files.
    const image = {} as IImage;
    if (e.thumbSmallFileId != null && entities.files.has(e.thumbSmallFileId)) {
        image.thumbSmallFile = entities.files.get(e.thumbSmallFileId);
    }
    if (e.thumbMediumFileId != null && entities.files.has(e.thumbMediumFileId)) {
        image.thumbMediumFile = entities.files.get(e.thumbMediumFileId);
    }
    if (e.fullsizeFileId != null && entities.files.has(e.fullsizeFileId)) {
        image.fullsizeFile = entities.files.get(e.fullsizeFileId);
    }

    return e.merge(image) as Image;
};
